// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3zctNirPs14qIa {\n  background-color: #F4F5F7;\n  margin: -8px -12px 8px -12px;\n  padding: 24px;\n}\n._3zctNirPs14qIa ._3GEAxzyauHGoLq {\n  font-size: 16px;\n  margin-bottom: 4px;\n}\n._3zctNirPs14qIa ._1mKbzuxDYrWRYc {\n  margin-bottom: 16px;\n}\n._3zctNirPs14qIa ._3mI8y9FZS_l01D {\n  margin-bottom: 20px;\n}\n._3zctNirPs14qIa ._2WV-LdMBk8m11Y ._10W0ccLS7VIDn6 {\n  margin-top: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_3zctNirPs14qIa",
	"greeting": "_3GEAxzyauHGoLq",
	"noticeOfReplacementText": "_1mKbzuxDYrWRYc",
	"explanationOfAgreementText": "_3mI8y9FZS_l01D",
	"agreeToTosButton": "_2WV-LdMBk8m11Y",
	"button": "_10W0ccLS7VIDn6"
};
export default ___CSS_LOADER_EXPORT___;
